module.exports = __webpack_public_path__ + "img/fr.09a791be0aa03e3b35933c12cbf618f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fr.png
// module id = 720
// module chunks = 0